import { Equipamentos } from "./Equipamentos";

export default Equipamentos